import {
  ACTION_CLEAR_TOAST,
  ACTION_ERROR,
  ACTION_INFO,
  ACTION_SUCCESS,
} from '~/redux/commonActions'

const toastrEpic = (
  action$,
  _,
  { clearToast, showError, showInfo, showSuccess }
) =>
  action$
    .ofType(ACTION_CLEAR_TOAST, ACTION_ERROR, ACTION_INFO, ACTION_SUCCESS)
    .do((action) => {
      switch (action.type) {
        case ACTION_CLEAR_TOAST:
          clearToast()
          break
        case ACTION_ERROR:
          showError(action.payload)
          break
        case ACTION_INFO:
          showInfo(action.payload)
          break
        case ACTION_SUCCESS:
          showSuccess(action.payload)
          break
      }
    })
    .filter(() => false)

export default toastrEpic
